// verseFormat.js — Padronização visual de referências bíblicas (ARC).
//
// Landing e app costumam publicar "Sl 34.15 (ARC)" com PONTO entre capítulo
// e versículo. Muitos usuários preferem visualmente o padrão "Sl 34:15 (ARC)"
// com DOIS PONTOS. Este helper converte para dois pontos SEM tocar em nada
// mais — livros com número (1Tm, 2Cr, 3Jo) e versos com traço (Ef 4:31-32)
// permanecem intactos.
//
// Regra: capítulo e versículo são SEMPRE numéricos. O padrão é
//   <livro> <cap>.<verso>            → <livro> <cap>:<verso>
//   <livro> <cap>.<vFrom>-<vTo>      → <livro> <cap>:<vFrom>-<vTo>
//
// NÃO altera "1Tm" (número no livro) porque a lookahead exige espaço antes
// do capítulo.

export function formatVerseRef(ref) {
  if (!ref || typeof ref !== "string") return ref || "";
  // Substitui apenas o PRIMEIRO ponto entre dois números após um espaço.
  // (\d+) → capítulo | \. → ponto separador | (\d+) → versículo inicial
  return ref.replace(/(\s\d+)\.(\d+)/g, "$1:$2");
}

/**
 * Sanitiza a "confusão de fonte" onde "Sl" (L minúsculo) pode parecer "SI"
 * (I maiúsculo) em fontes sans-serif. Não muda o dado — só garante que
 * abreviações comuns são renderizadas com L minúsculo consistente.
 * Usado defensivamente: se algum payload chegar com "SI 34:15" (bug real),
 * corrigimos aqui antes de renderizar.
 */
export function normalizeBookAbbr(ref) {
  if (!ref || typeof ref !== "string") return ref || "";
  return ref
    .replace(/\bSI\b/g, "Sl") // Salmos: SI (I maiúsculo) → Sl (L minúsculo)
    .replace(/\bSl\.\s/g, "Sl "); // "Sl. 23" → "Sl 23"
}

/**
 * Formata a referência aplicando ambas as normalizações.
 */
export function formatVerse(ref) {
  return formatVerseRef(normalizeBookAbbr(ref));
}
